interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  id?: string;
}

export default function SectionHeading({ eyebrow, title, desc, align = "left", id }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`${isCenter ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}`}>
      {eyebrow && (
        <p className="inline-flex items-center gap-2 text-xs font-label tracking-widest text-primary-600 uppercase">
          <span className="w-5 h-px bg-primary-400"></span>
          {eyebrow}
        </p>
      )}
      <h2
        id={id}
        className="mt-3 font-heading text-2xl md:text-[32px] font-bold text-foreground-950 leading-snug"
      >
        {title}
      </h2>
      {desc && <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
    </div>
  );
}